import { Controller } from "@hotwired/stimulus"

// Zapamiętuje per user rozwinięcie sekcji sidebara (<details>) - zapis do user_setting
// pod kluczem z key-value (np. automation.menu_open.escalations) przy każdym przełączeniu.
// Sidebar renderuje się serwerowo, więc następne wejście na stronę czyta już zapisany stan.
// Użycie: data-controller="sidebar-section" data-sidebar-section-key-value="..."
//         data-action="toggle->sidebar-section#persist" na elemencie <details>
export default class extends Controller {
  static values = { key: String }

  persist() {
    if (!this.keyValue) return
    window.IntumJs.setField(this.keyValue, this.element.open, { check: false })
  }
}
